import React from 'react';
import './InvoiceReadyGauge.css';

function InvoiceReadyGauge({ totalTimeSpend, ready4InvoiceTimeSpend, compact = false }) {
  const total = Number(totalTimeSpend) || 0;
  const ready = Number(ready4InvoiceTimeSpend) || 0;
  const percentage = total > 0 ? Math.round((ready / total) * 100) : 0;

  const radius = compact ? 36 : 52;
  const circumference = Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  let tone = 'warning';
  if (percentage >= 80) tone = 'great';
  else if (percentage >= 60) tone = 'ok';

  const label = `${percentage}% invoice-ready time`;

  return (
    <div
      className={`invoice-ready-gauge tone-${tone}${compact ? ' compact' : ''}`}
      title={label}
      aria-label={label}
    >
      <div className="invoice-ready-gauge-visual">
        <svg viewBox="0 0 120 70" className="invoice-ready-gauge-svg" aria-hidden="true">
          <path
            className="invoice-ready-gauge-track"
            d="M 10 60 A 50 50 0 0 1 110 60"
            fill="none"
            strokeWidth="10"
            strokeLinecap="round"
          />
          <path
            className="invoice-ready-gauge-fill"
            d="M 10 60 A 50 50 0 0 1 110 60"
            fill="none"
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <span className="invoice-ready-gauge-percent">{percentage}%</span>
      </div>
    </div>
  );
}

export default InvoiceReadyGauge;
